import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "navbar-announcement",
  templateUrl: "./navbar-announcement.component.html",
  styleUrls: ["./navbar-announcement.component.scss"],
})
export class NavbarAnnouncementComponent implements OnInit {
  @Input() hasFrozenEnrollment: boolean;
  @Input() isStarter: boolean;

  constructor() {}

  ngOnInit() {}

  getCurrentYearTwoDigit() {
    return parseInt(new Date().getFullYear().toString().substr(-2));
  }
}
